import { type Enum } from '@webapp/infrastructure/types/Enum'

export const SettingsPermissionCategories = {
  SETUP: 'setup',
  ACCESS: 'access',
  PAYMENTS: 'payments',
  FINANCE: 'finance',
  CUSTOMIZATIONS: 'customizations',
  TOOLS: 'tools',
} as const
export type SettingsPermissionCategoryEnum = Enum<
  typeof SettingsPermissionCategories
>
